module.exports = phone => {
    const israelLocalPhoneRegex = /^0\d([\d]{0,1})([-]{0,1})\d{7}$/im;

    return israelLocalPhoneRegex.test(phone);
};
